<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-11-29 09:38:15
 * @LastEditors: quwandong
 * @LastEditTime: 2022-07-29 09:58:04
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
      <div>
        <el-form
          ref="filterForm"
          :inline="true"
          :model="filterForm"
          class="filter-form"
        >
          <el-form-item prop="trustee" v-if="!$route.query.$businessName">
            <el-input
              v-model="filterForm.trustee"
              placeholder="合作社名称"
              style="width: 260px"
            ></el-input>
          </el-form-item>
          <el-form-item prop="villageId">
            <el-cascader
              v-model="checkedRegionData"
              :props="regionProps"
              :options="regionData"
              :show-all-levels="false"
              placeholder="所属村"
            ></el-cascader>
          </el-form-item>
          <el-form-item prop="cropId">
            <el-select
              v-model="filterForm.cropId"
              placeholder="种植作物"
              style="width: 120px"
            >
              <el-option label="全部" value="0"></el-option>
              <el-option
                v-for="item in cropData"
                :key="item.id"
                :label="item.cropName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="workType">
            <el-select
              v-model="filterForm.workType"
              placeholder="作业类型"
              style="width: 150px"
            >
              <el-option label="全部" value="0"></el-option>
              <el-option
                v-for="item in workTypeData"
                :key="item.id"
                :label="item.workTypeName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="statusFlag">
            <el-select
              v-model="filterForm.statusFlag"
              placeholder="订单状态"
              style="width: 120px"
            >
              <el-option label="全部" value="0"></el-option>
              <el-option
                v-for="item in uniqeGlobalDict$$['3']"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleFilterPro('filterForm')"
              >查询</el-button
            >
            <el-button
              type="primary"
              plain
              @click="handleResetFilter('filterForm')"
              ><i class="el-icon-refresh-right"></i>清空</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="main">
      <!-- 为了使用空白页面 -->
      <el-table
        v-if="orders.length == 0"
        :data="orders"
        style="width: 100%; margin-top: 10px"
      >
        <el-table-column label="序号" width="80" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="orderNum"
          label="订单编号"
          min-width="8%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="orderTypeName"
          label="订单类型"
          min-width="6%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="cropName"
          label="种植作物"
          min-width="6%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="orderTime"
          label="作业时间要求"
          min-width="16%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="workTypeNames"
          label="作业类型"
          min-width="10%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="orderArea"
          label="流转面积（亩）"
          min-width="7%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="workArea"
          label="作业面积（亩）"
          min-width="7%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="statusName"
          label="状态"
          min-width="6%"
          align="center"
        >
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          min-width="6%"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              plain
              round
              @click="handleLookDetail(scope.row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <ul v-else class="list">
        <li class="item" v-for="(item, index) in orders" :key="index">
          <div class="top-info">
            <div class="cell number">
              <p>
                <i
                  class="iconfont icon-hetongdingdantubiao"
                  style="font-size: 18px; font-weight: 900; margin-right: 5px"
                ></i>
              </p>
              <p>
                <span>合同编号：</span>
                {{ item.contractNum }}
              </p>
            </div>
            <p class="cell"><span>合作社：</span>{{ item.trustee }}</p>
            <p class="cell"><span>所属村：</span>{{ item.villageName }}</p>
            <p class="cell">
              <span>合同期限：</span
              >{{ item.allottedTimeBegin | formatDate }}~{{
                item.allottedTimeEnd | formatDate
              }}
            </p>
            <p class="cell"><span>流转面积：</span>{{ item.orderArea }}亩</p>
          </div>
          <el-table :data="item.orderProtocolList" style="width: 100%">
            <el-table-column label="序号" width="80" align="center">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column
              prop="orderNum"
              label="订单编号"
              min-width="8%"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="orderTypeName"
              label="订单类型"
              min-width="6%"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="cropName"
              label="种植作物"
              min-width="6%"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="orderTime"
              label="作业时间要求"
              min-width="16%"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="workTypeNames"
              label="作业类型"
              min-width="10%"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="orderArea"
              label="流转面积（亩）"
              min-width="7%"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="workArea"
              label="作业面积（亩）"
              min-width="7%"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="statusName"
              label="状态"
              min-width="6%"
              align="center"
            >
            </el-table-column>
            <el-table-column label="操作" min-width="6%" align="center">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  plain
                  round
                  @click="handleLookDetail(scope.row)"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </li>
      </ul>
      <el-pagination
        background
        layout="total,prev, pager, next,jumper"
        :page-size="this.pagination.pageSize"
        :total="pagination.recordTotal"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </el-main>
</template>

<script>
import regionSeatLibs from 'utils/regionSeatLibs'
let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c))
export default {
  name: 'OrderList',
  $dictKeyList: [
    {
      key: '3',
      name: '订单状态',
    },
  ],
  data() {
    const that = this
    return {
      filterForm: {
        orderCategory: 3, //2: 托管订单，3：流转订单
        trustee: '',
        villageId: '',
        cropId: '',
        workType: '',
        statusFlag: '',
        trusteeAccountId: '',
      },
      regionProps: {
        value: 'i',
        label: 'n',
        children: 'c',
        lazy: true,
        lazyLoad(node, resolve) {
          const { level, children, label, value, data } = node
          // 直辖市的二级（例：海淀区）flag：true代表直辖市
          if (level == 2 && children.length == 0) {
            that.getChildRegion(value, level >= 3, resolve, true)
          }
          if (level == 3 && children.length == 0 && label != '市辖区') {
            let leaf = false
            if (data.flag) {
              leaf = true
            } else {
              leaf = false
            }
            that.getChildRegion(value, leaf, resolve)
          } else if (level >= 4) {
            that.getChildRegion(value, level >= 4, resolve)
          } else {
            resolve()
          }
        },
      },
      regionData: Object.freeze(regionData),
      checkedRegionData: [],
      cropData: [],
      workTypeData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      allFilters: {},
      orders: [],
    }
  },
  filters: {
    formatDate(value) {
      let result = ''
      let ary = value.split('-')
      result = `${ary[0]}年${ary[1]}月${ary[2]}日`
      return result
    },
  },
  watch: {
    'filterForm.cropId'(newValue) {
      if (newValue != 0) {
        this.filterForm.workType = ''
        this.workTypeData = []
        this.getCropWork2({ cropId2: newValue })
      }
    },
    checkedRegionData(n) {
      this.filterForm.villageId = n[n.length - 1]
    },
  },
  mounted() {
    this.filterForm.trusteeAccountId = this.$route.query.$businessAccountId
    this.getOrderList()
    this.getAllCropList()
    this.getCropWork2()
  },
  methods: {
    /**
     * @descripttion: 获取地区子级数据
     * @Author: juanjuanhui
     * @Date: 2022-04-02 15:45:04
     * @param {*} value 当前节点的value
     * @param {*} leaf 当前节点的leaf
     * @param {*} resolve
     * @param {*} flag 是否是直辖市的标志 非必传
     */
    getChildRegion(value, leaf, resolve, flag) {
      this.$http.common.getChildRegion({ pid: value }).then((res) => {
        let nodes = res.data
        if (flag) {
          nodes.forEach((item) => {
            item.leaf = leaf
            item.flag = flag
          })
        } else {
          nodes.forEach((item) => {
            item.leaf = leaf
          })
        }
        // 通过调用resolve将子节点数据返回，通知组件数据加载完成
        resolve(nodes)
      })
    },
    /**
     * @descripttion: 获取种植作物下拉框数据
     * @Author: juanjuanhui
     * @Date: 2021-12-19 14:12:00
     */
    getAllCropList() {
      this.$http.common.getAllCropList().then((res) => {
        this.cropData = res.data
      })
    },
    /**
     * @descripttion: 获取作业类型二级数据
     * @Author: juanjuanhui
     * @Date: 2021-12-19 14:18:11
     */
    getCropWork2(params) {
      this.$http.common.getCropWork2(params).then((res) => {
        this.workTypeData = res.data
      })
    },
    /**
     * @descripttion: 查询机具
     * @Author: juanjuanhui
     * @Date: 2021-11-30 10:33:18
     */
    handleFilterPro() {
      this.pagination.currentPage = 1
      this.getOrderList()
    },
    /**
     * @descripttion: 重置筛选条件
     * @Author: juanjuanhui
     * @Date: 2021-11-30 10:34:18
     * @param {String} formName 表单ref名称
     */
    handleResetFilter(formName) {
      this.$refs[formName].resetFields()
      this.checkedRegionData = []
      this.pagination.currentPage = 1
      this.getOrderList()
    },
    /**
     * @descripttion: 获取查询参数
     * @Author: juanjuanhui
     * @Date: 2021-11-30 10:35:18
     */
    getAllFilters() {
      this.allFilters = { ...this.filterForm }
      if (this.allFilters.cropId == 0) {
        delete this.allFilters.cropId
      }
      if (this.allFilters.workType == 0) {
        delete this.allFilters.workType
      }
      if (this.allFilters.statusFlag == 0) {
        delete this.allFilters.statusFlag
      }
    },
    /**
     * @descripttion: 获取订单列表
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:18:08
     * @param {*}
     */
    getOrderList() {
      this.getAllFilters()
      let { currentPage, pageSize } = this.pagination
      let params = { currentPage, pageSize }
      Object.assign(params, params, this.allFilters)
      this.$http.order.getOrderList(params).then((res) => {
        let { recordTotal, content: orders } = res.data
        this.pagination.recordTotal = recordTotal
        this.orders = orders
      })
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:24:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getOrderList()
    },
    /**
     * @descripttion: 查看详情
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:04:18
     * @param {*} params
     */
    handleLookDetail(params) {
      this.$router.push({
        path: '/cooperative/transfer/order/detail',
        query: { id: params.id },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/common.scss';
.main {
  .list {
    .item {
      margin-bottom: 20px;
      .top-info {
        display: flex;
        align-items: center;
        color: #018388;
        .cell {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          margin-right: 4%;
          &:first-child {
            flex-wrap: nowrap;
          }
          &:nth-child(5) {
            margin-right: 0;
          }
          &.number {
            font-weight: 900;
          }
        }
        .btn {
          height: 34px;
          line-height: 34px;
          padding: 0 15px;
          margin-left: auto;
        }
      }
      .el-table {
        margin-top: 10px;
      }
    }
  }
}
::v-deep .preview-img {
  position: absolute;
  z-index: -1;
  width: 100px;
  height: 100px;
}
</style>
